import { ChangeDetectionStrategy, Component, OnInit, inject, signal, computed } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import * as fromRoot from '@core/redux';
import * as AuthActions from '@core/redux/auth/auth.actions';
import { getToken } from '@core/utils/getToken';
import { select, Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-invite-confirm',
  templateUrl: './invite-confirm.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  styleUrls: ['./invite-confirm.component.less'],
  imports: [],
})
export class InviteConfirmComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private store = inject<Store<fromRoot.State>>(Store);

  // Сигналы для состояния компонента
  errors = signal<{ token?: string } | null>(null);

  // Вычисляемый сигнал для определения кнопки
  nextButton = computed(() => {
    const currentErrors = this.errors();
    if (currentErrors && currentErrors.token) {
      const token = getToken();
      return token ? 'goCabinet' : 'goSignIn';
    }
    return null;
  });

  // Вычисляемый сигнал для проверки наличия ошибок
  hasErrors = computed(() => {
    const currentErrors = this.errors();
    return currentErrors && currentErrors.token;
  });

  constructor() {
    // Подписка на параметры маршрута
    this.route.params
      .pipe(
        takeUntilDestroyed(),
        filter(params => !!params['token'])
      )
      .subscribe(params => {
        this.store.dispatch(new AuthActions.InviteConfirmationAction(params['token']));
      });

    // Подписка на ошибки из store
    this.store.pipe(select(fromRoot.getAuthErrors), takeUntilDestroyed()).subscribe(errors => {
      this.errors.set(errors);
    });
  }

  ngOnInit() {}
}
